"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { cn } from "@repo/design-system/utils/cn";
import { displayDate, isBeforeToday } from "@repo/design-system/utils/date-helpers";
import { Mail, Phone } from "lucide-react";
import { useRegistry } from "~/components/registry/registry-provider";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function Contact(t0) {
  const $ = _c(35);
  const {
    job
  } = t0;
  const t = useLanguage();
  const recruiterData = job.data.recruiterData;
  if (!recruiterData) {
    return null;
  }
  const displayLocale = t.i18n === "de" ? "de" : "es";
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== displayLocale || $[1] !== job.data.applicationEnd || $[2] !== job.data.idClient || $[3] !== recruiterData.recruiter_text || $[4] !== t) {
    const deadline = job.data.applicationEnd ? displayDate(job.data.applicationEnd.slice(0, 10), t, displayLocale) : null;
    const validIds = ["230421", "232072", "232073", "232074", "232075", "232076", "232078", "232079", "232081", "232083"];
    const isIntGraduate = validIds.includes(job.data.idClient);
    t7 = "outer-container bg-primary py-container text-lg text-white";
    t8 = "contact";
    t6 = "inner-container";
    t5 = "grid gap-3 lg:grid-cols-2";
    t3 = "flex flex-col";
    if ($[13] !== t.jobad_contactHL) {
      t4 = <div className="mb-8 flex w-full font-medium text-4xl lg:text-5xl"><h2 className="lg:w-96" data-source="lc">{t.jobad_contactHL}</h2></div>;
      $[13] = t.jobad_contactHL;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t1 = "pb-6";
    t2 = isIntGraduate ? recruiterData.recruiter_text && <div className="hover:[&_a]:underline" dangerouslySetInnerHTML={{
      __html: recruiterData.recruiter_text.replace("{deadline}", deadline ? deadline.toString() : "")
    }} /> : <><div dangerouslySetInnerHTML={{
        __html: recruiterData.recruiter_text || ""
      }} data-source="job" />{job.data.applicationEnd && !isBeforeToday(job.data.applicationEnd) ? <p data-source="lc">{t.jobad_contact_applicationEnd}<span className="font-bold" data-source="job">{deadline}</span></p> : <p data-source="lc">{t.jobad_details_applicationDeadline}</p>}</>;
    $[0] = displayLocale;
    $[1] = job.data.applicationEnd;
    $[2] = job.data.idClient;
    $[3] = recruiterData.recruiter_text;
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[15] !== t1 || $[16] !== t2) {
    t9 = <div className={t1}>{t2}</div>;
    $[15] = t1;
    $[16] = t2;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t9) {
    t10 = <div className={t3}>{t4}{t9}</div>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== job) {
    t11 = <div className="flex justify-end"><ContactImage job={job} /></div>;
    $[22] = job;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t5) {
    t12 = <div className={t5}>{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t5;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t12 || $[29] !== t6) {
    t13 = <div className={t6}>{t12}</div>;
    $[28] = t12;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t7 || $[33] !== t8) {
    t14 = <section className={t7} id={t8}>{t13}</section>;
    $[31] = t13;
    $[32] = t7;
    $[33] = t8;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  return t14;
}
export function ContactImage(t0) {
  const $ = _c(25);
  const {
    job,
    sticky
  } = t0;
  const t = useLanguage();
  const {
    ui
  } = useRegistry();
  const recruiterData = job.data.recruiterData;
  if (!recruiterData) {
    return null;
  }
  const t1 = sticky && "max-h-[220px] w-3xs object-contain md:max-h-[380px]";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("ml-auto w-4/5 translate-y-10 bg-white object-cover object-top", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${ui.recruiterImageBasePath}/${recruiterData.recruiter_image}`;
  let t4;
  if ($[2] !== t2 || $[3] !== t3) {
    t4 = <CustomImage alt="Recruiter" className={t2} height={250} src={t3} width={300} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== recruiterData.recruiter_mail || $[6] !== t) {
    t5 = recruiterData.recruiter_mail && <CustomLink className="flex gap-x-2 font-medium hover:underline" href={`mailto:${recruiterData.recruiter_mail}`} title={t.jobad_contact_sendMail}><span className="sr-only" data-source="lc">{t.jobad_contact_sendMail}:{" "}</span><div className="w-8"><Mail aria-hidden={true} className="size-6" /></div><p dangerouslySetInnerHTML={{
        __html: recruiterData.recruiter_mail.replaceAll("@", "&shy;@")
      }} data-source="job" /></CustomLink>;
    $[5] = recruiterData.recruiter_mail;
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== recruiterData.recruiter_phone || $[9] !== t) {
    t6 = recruiterData.recruiter_phone && <CustomLink className="flex gap-x-2 font-medium hover:underline" href={`tel:${recruiterData.recruiter_phone}`} title={t.jobad_contact_call}><span className="sr-only" data-source="lc">{t.jobad_contact_call}:{" "}</span><Phone aria-hidden={true} className="h-7 w-8" /><p data-source="job">{recruiterData.recruiter_phone}</p></CustomLink>;
    $[8] = recruiterData.recruiter_phone;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== job) {
    t7 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton className="w-fit rounded-xl" job={job} />;
    $[11] = job;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== job) {
    t8 = job.data.applicationUrlDirect && <ApplyButton className="w-fit rounded-xl" direct={true} job={job} />;
    $[13] = job;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <div className="mt-4 flex flex-col gap-2">{t7}{t8}</div>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t5 || $[19] !== t6 || $[20] !== t9) {
    t10 = <div className="!pt-16 flex w-full flex-col gap-2 bg-white p-4 text-primary lg:p-6">{t5}{t6}{t9}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t4) {
    t11 = <div className="-mt-10 flex w-72 flex-col overflow-hidden sm:w-80 lg:w-96">{t4}{t10}</div>;
    $[22] = t10;
    $[23] = t4;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
}